import React from 'react';
import Button from '../../components/ui/Button';
import { useTranslation } from 'react-i18next';

const MusicExperience = () => {

  const {t} = useTranslation();

  return (
    <section className="w-full bg-black">
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Text Content */}
          <div className="w-full lg:w-2/3 text-center lg:text-left">
            <div className="flex flex-col gap-4 lg:gap-6 max-w-2xl mx-auto lg:mx-0">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#f9f9f9] leading-tight lg:leading-[50px]">
                {t("enhance")}
              </h2>
              
              <div className="mt-6 lg:mt-8">
                <Button
                  text={t("explore_now")}
                  text_font_size="16"
                  text_font_family="Poppins"
                  text_font_weight="500"
                  text_line_height="24px"
                  text_text_align="left"
                  text_color="#f9f9f9"
                  fill_background_color="#d21f3d"
                  border_border_radius="2px"
                  padding="4px"
                  className="hover:opacity-90 transition-opacity"
                  layout_width="auto"
                  position="relative"
                  layout_gap="0"
                  margin="0"
                  variant="primary"
                  size="medium"
                  onClick={() => {}}
                />
              </div>
            </div>
          </div>

          {/* Product Image */}
          <div className="w-full lg:w-1/3 flex justify-center">
            <div className="relative">
              {/* Background Circle */}
              <div className="w-[226px] h-[224px] bg-[#d9d9d94c] rounded-full shadow-[0px_4px_200px_#888888ff] absolute top-0 left-4"></div>
              
              {/* Product Image */}
              <img
                src="/images/img_71sthhxcp8l_1.png"
                alt="Premium Headphones - Enhance Your Music Experience"
                className="relative z-10 w-[206px] h-[206px] object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MusicExperience;